<div class="edit-panel">
  <div class="d-flex">
    <app-mid-icon-button type="primary" (action)="close()">
      <i class="fas fa-times"></i>
    </app-mid-icon-button>

    <div class="labels ml-3">
      <div class="description-box">
        <div class="description">
          {{ date | date : 'dd MMMM yyyy / HH:mm' : undefined : translate.getDefaultLang() }}
        </div>
      </div>
    </div>
  </div>

  <app-mid-button [matMenuTriggerFor]="actionsMenu" type="secondary">
    {{ 'TDRAW.ACTIONS' | translate }} <i class="fas fa-ellipsis-v ml-3"></i>
  </app-mid-button>
</div>

<mat-menu #actionsMenu="matMenu" class="mid-menu" panelClass="pt-0">
  <div class="mid-menu-item" (click)="printSnapshot()">
    <i class="fas fa-print mr-2 mid-menu-item-icon"></i>
    {{ 'TDRAW.PRINT' | translate }}
  </div>
  <div class="mid-menu-item" (click)="downloadSnapshot()">
    <i class="fas fa-camera mr-2 mid-menu-item-icon"></i>
    {{ 'TDRAW.SCREENSHOT' | translate }}
  </div>
  <div class="mid-menu-item" (click)="saveData()">
    <i class="fas fa-clipboard-check mr-2 mid-menu-item-icon"></i>
    {{ 'SAVE' | translate }}
  </div>
  <div class="mid-menu-item" (click)="openExportModal()">
    <i class="fas fa-file-export mr-2 mid-menu-item-icon"></i>
    {{ 'EXPORT' | translate }}
  </div>
  <div class="mid-menu-item" (click)="publishHistory()">
    <i class="fas fa-reply mr-2 mid-menu-item-icon"></i>
    {{ 'PUBLISH' | translate }}
  </div>
</mat-menu>

<div class="map-container">
  <div class="mapbox-container">
    <div id="map-pic-edit"></div>
    <tdraw-mapmode-info [isEditable]="true"> </tdraw-mapmode-info>

    <div class="right-toolbox" [class.sticky-toolbox]="rightPanelData.mode === RightPanelMode.Hidden">
      <div class="right-tool-button">
        <button (click)="onDrawLine()">
          <img src="/assets/images/tool-icons/tool1.svg" width="20" height="20" />
        </button>
      </div>
      <div class="right-tool-button">
        <button (click)="onDrawPolygon()">
          <img src="/assets/images/tool-icons/tool2.svg" width="20" height="20" />
        </button>
      </div>
    </div>
  </div>

  <tdraw-right-panel [data]="rightPanelData">
    <tdraw-pic-edition-properties-panel
      *ngIf="rightPanelData.mode === RightPanelMode.Properties"
      [editModeManager]="editModeManager"
      (goToToolbox)="setRightPanelMode(RightPanelMode.Navigation)"
      (delete)="onDeleteSource()"
    >
    </tdraw-pic-edition-properties-panel>

    <tdraw-tools-panel *ngIf="mapState" [class.d-none]="rightPanelData.mode !== RightPanelMode.Navigation">
      <tdraw-tools-panel-tab [title]="'INFORMATIONS' | translate" fa-icon="far fa-file-alt">
        <tdraw-pic-info-tab [mediaId]="mapState.backgroundMedia?.mediaId"> </tdraw-pic-info-tab>
      </tdraw-tools-panel-tab>

      <tdraw-tools-panel-tab [title]="'SYMBOLS' | translate" fa-icon="fas fa-flag-checkered">
        <tdraw-pic-symbols-tab
          (drawIcon)="onDrawIcon($event)"
          (drawCircle)="onDrawCircle($event)"
          (drawAllCircles)="onDrawAllCircles()"
          (drawCone)="drawCone()"
          (openMarkerCreationModal)="markerCreationSelection()"
          [(statistics)]="mapState.statistics"
        >
        </tdraw-pic-symbols-tab>
      </tdraw-tools-panel-tab>

      <tdraw-tools-panel-tab [title]="'LAYERS' | translate" fa-icon="fas fa-layer-group">
        <tdraw-layers-tab [mapModeManager]="editModeManager" [statistics]="mapState.statistics"> </tdraw-layers-tab>
      </tdraw-tools-panel-tab>
    </tdraw-tools-panel>
  </tdraw-right-panel>
</div>
